import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import { AnswersOnQuestions } from '../../components/AnswersOnQuestions';

export const AnswersOnQuestionsContainer = () => {
  const device = useDeviceType();
  const [activeFaqIndex, setFaqActiveIndex] = React.useState<number | null>(null);

  const handleFaqItemClick = React.useCallback(
    (index: number) => setFaqActiveIndex(prevIndex => (prevIndex === index ? null : index)),
    [],
  );

  return <AnswersOnQuestions deviceType={device} activeFaqIndex={activeFaqIndex} onFaqItemClick={handleFaqItemClick} />;
};
